module.exports = __webpack_public_path__ + "img/d201206-2.175faf4b.jpg";